import Vue from "vue";
// Import styles
import "vue-material-design-icons/styles.css";
// Import components
import AccountIcon from "vue-material-design-icons/Account.vue";
import AccountNetworkIcon from "vue-material-design-icons/AccountNetwork.vue";
import AlertCircleOutlineIcon from "vue-material-design-icons/AlertCircleOutline.vue";
import AlertIcon from "vue-material-design-icons/Alert.vue";
import AlertOctagonOutlineIcon from "vue-material-design-icons/AlertOctagonOutline.vue";
import ArchiveAlertOutlineIcon from "vue-material-design-icons/ArchiveAlertOutline.vue";
import ArchiveIcon from "vue-material-design-icons/Archive.vue";
import ArrowDownIcon from "vue-material-design-icons/ArrowDown.vue";
import ArrowDownThickIcon from "vue-material-design-icons/ArrowDownThick.vue";
import ArrowLeftIcon from "vue-material-design-icons/ArrowLeft.vue";
import ArrowRightCircleOutlineIcon from "vue-material-design-icons/ArrowRightCircleOutline.vue";
import ArrowRightIcon from "vue-material-design-icons/ArrowRight.vue";
import ArrowUpIcon from "vue-material-design-icons/ArrowUp.vue";
import ArrowUpThickIcon from "vue-material-design-icons/ArrowUpThick.vue";
import AtIcon from "vue-material-design-icons/At.vue";
import AttachmentIcon from "vue-material-design-icons/Attachment.vue";
import AutoRenewIcon from "vue-material-design-icons/Autorenew.vue";
import AutoRenewOffIcon from "vue-material-design-icons/AutorenewOff.vue";
import BellAlertIcon from "vue-material-design-icons/BellAlert.vue";
import BellIcon from "vue-material-design-icons/Bell.vue";
import BellOffIcon from "vue-material-design-icons/BellOff.vue";
import BellSleepIcon from "vue-material-design-icons/BellSleep.vue";
import BugIcon from "vue-material-design-icons/Bug.vue";
import BullhornIcon from "vue-material-design-icons/Bullhorn.vue";
import CakeVariantIcon from "vue-material-design-icons/CakeVariant.vue";
import CalculatorIcon from "vue-material-design-icons/Calculator.vue";
import CalendarCheckIcon from "vue-material-design-icons/CalendarCheck.vue";
import CalendarIcon from "vue-material-design-icons/Calendar.vue";
import CalendarMonth from "vue-material-design-icons/CalendarMonth.vue";
import CalendarPlusOutlineIcon from "vue-material-design-icons/CalendarPlus.vue";
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import CardPlusIcon from "vue-material-design-icons/CardPlus.vue";
import CheckAllIcon from "vue-material-design-icons/CheckAll.vue";
import CheckBoldIcon from "vue-material-design-icons/CheckBold.vue";
import CheckCircleIcon from "vue-material-design-icons/CheckCircle.vue";
import CheckCircleOutlineIcon from "vue-material-design-icons/CheckCircleOutline.vue";
import CheckIcon from "vue-material-design-icons/Check.vue";
import CheckboxMarkedOutline from "vue-material-design-icons/CheckboxMarkedOutline.vue";
import CheckboxMultipleOutlineIcon from "vue-material-design-icons/CheckboxMultipleMarkedOutline.vue";
import CheckboxOutline from "vue-material-design-icons/CheckboxOutline.vue";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import ChevronLeftIcon from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";
import ChevronUpIcon from "vue-material-design-icons/ChevronUp.vue";
import ClockTimeIcon from "vue-material-design-icons/ClockOutline.vue";
import CloseCircleIcon from "vue-material-design-icons/CloseCircle.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";
import CloseOctagonIcon from "vue-material-design-icons/CloseOctagon.vue";
import CloseThickIcon from "vue-material-design-icons/CloseThick.vue";
import CogClockwiseIcon from "vue-material-design-icons/CogClockwise.vue";
import CogIcon from "vue-material-design-icons/Cog.vue";
import CogOffOutlineIcon from "vue-material-design-icons/CogOffOutline.vue";
import CogOutlineIcon from "vue-material-design-icons/CogOutline.vue";
import CommentOutlineIcon from "vue-material-design-icons/CommentOutline.vue";
import CommentTextOutlineIcon from "vue-material-design-icons/CommentTextOutline.vue";
import ContentCopyIcon from "vue-material-design-icons/ContentCopy.vue";
import ContentCutIcon from "vue-material-design-icons/ContentCut.vue";
import ContentSaveIcon from "vue-material-design-icons/ContentSave.vue";
import CreditCardIcon from "vue-material-design-icons/CreditCard.vue";
import SyncIcon from "vue-material-design-icons/Sync.vue";
import DatabaseSyncIcon from "vue-material-design-icons/DatabaseSync.vue";
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import DotsVerticalIcon from "vue-material-design-icons/DotsVertical.vue";
import DownloadIcon from "vue-material-design-icons/Download.vue";
import EmailFastIcon from "vue-material-design-icons/EmailFast.vue";
import EmailIcon from "vue-material-design-icons/Email.vue";
import EmailLockIcon from "vue-material-design-icons/EmailLock.vue";
import EmailMultipleOutlineIcon from "vue-material-design-icons/EmailMultipleOutline.vue";
import EmailOutlineIcon from "vue-material-design-icons/EmailOutline.vue";
import EmailPlusOutlineIcon from "vue-material-design-icons/EmailPlusOutline.vue";
import EmailRemoveIcon from "vue-material-design-icons/EmailRemove.vue";
import EmailSearchIcon from "vue-material-design-icons/EmailSearch.vue";
import EyeCheckIcon from "vue-material-design-icons/EyeCheck.vue";
import EyeIcon from "vue-material-design-icons/Eye.vue";
import EyeOffIcon from "vue-material-design-icons/EyeOff.vue";
import FileChartIcon from "vue-material-design-icons/FileChart.vue";
import FileCodeIcon from "vue-material-design-icons/FileCode.vue";
import FileExcelIcon from "vue-material-design-icons/FileExcel.vue";
import FileIcon from "vue-material-design-icons/File.vue";
import FileImageIcon from "vue-material-design-icons/FileImage.vue";
import FilePdfIcon from "vue-material-design-icons/FilePdfBox.vue";
import FilePlusIcon from "vue-material-design-icons/FilePlus.vue";
import FileWordIcon from "vue-material-design-icons/FileWord.vue";
import FilterIcon from "vue-material-design-icons/Filter.vue";
import FilterVariantIcon from "vue-material-design-icons/FilterVariant.vue";
import GenderFemaleIcon from "vue-material-design-icons/GenderFemale.vue";
import GenderMaleIcon from "vue-material-design-icons/GenderMale.vue";
import HelpCircleOutlineIcon from "vue-material-design-icons/HelpCircleOutline.vue";
import HelpIcon from "vue-material-design-icons/Help.vue";
import HomeAlertIcon from "vue-material-design-icons/HomeAlert.vue";
import HomeAnalyticsIcon from "vue-material-design-icons/HomeAnalytics.vue";
import HomeIcon from "vue-material-design-icons/Home.vue";
import InformationOutlineIcon from "vue-material-design-icons/InformationOutline.vue";
import LanIcon from "vue-material-design-icons/Lan.vue";
import LinkVariantIcon from "vue-material-design-icons/LinkVariant.vue";
import LinkVariantOffIcon from "vue-material-design-icons/LinkVariantOff.vue";
import LoadingIcon from "vue-material-design-icons/Loading.vue";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import MenuIcon from "vue-material-design-icons/Menu.vue";
import MenuOpenIcon from "vue-material-design-icons/MenuOpen.vue";
import MessageIcon from "vue-material-design-icons/Message.vue";
import MicrosoftOutlookIcon from "vue-material-design-icons/MicrosoftOutlook.vue";
import NoteMultipleOutlineIcon from "vue-material-design-icons/NoteMultipleOutline.vue";
import NotePlusOutline from "vue-material-design-icons/NotePlusOutline.vue";
import OfficeBuildingIcon from "vue-material-design-icons/OfficeBuilding.vue";
import PackageIcon from "vue-material-design-icons/Package.vue";
import PaletteIcon from "vue-material-design-icons/Palette.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import PhoneIcon from "vue-material-design-icons/Phone.vue";
import PhoneReturnIcon from "vue-material-design-icons/PhoneReturn.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";
import PlaylistCheckIcon from "vue-material-design-icons/PlaylistCheck.vue";
import PlusIcon from "vue-material-design-icons/Plus.vue";
import PowerIcon from "vue-material-design-icons/Power.vue";
import PowerOffIcon from "vue-material-design-icons/PowerOff.vue";
import ResistorNodesIcon from "vue-material-design-icons/ResistorNodes.vue";
import RestoreIcon from "vue-material-design-icons/Restore.vue";
import SackPercentIcon from "vue-material-design-icons/SackPercent.vue";
import SelectionMultipleIcon from "vue-material-design-icons/SelectionMultiple.vue";
import SendCheckIcon from "vue-material-design-icons/SendCheck.vue";
import SendClockIcon from "vue-material-design-icons/SendClock.vue";
import SendIcon from "vue-material-design-icons/Send.vue";
import ServerIcon from "vue-material-design-icons/Server.vue";
import SignalVariantIcon from "vue-material-design-icons/SignalVariant.vue";
import SlashForwardIcon from "vue-material-design-icons/SlashForward.vue";
import StarIcon from "vue-material-design-icons/Star.vue";
import StarOutlineIcon from "vue-material-design-icons/StarOutline.vue";
import SyncCircleIcon from "vue-material-design-icons/SyncCircle.vue";
import SyncOffIcon from "vue-material-design-icons/SyncOff.vue";
import TagIcon from "vue-material-design-icons/Tag.vue";
import TargetAccountIcon from "vue-material-design-icons/TargetAccount.vue";
import ToolboxIcon from "vue-material-design-icons/Toolbox.vue";
import TooltipTextOutlineIcon from "vue-material-design-icons/TooltipTextOutline.vue";
import TrashIcon from "vue-material-design-icons/TrashCan.vue";
import UmbrellaIcon from "vue-material-design-icons/Umbrella.vue";
import UnfoldMoreHorizontalIcon from "vue-material-design-icons/UnfoldMoreHorizontal.vue";
import UploadIcon from "vue-material-design-icons/Upload.vue";
import UploadOutline from "vue-material-design-icons/UploadOutline.vue";
import ViewModuleIcon from "vue-material-design-icons/ViewModule.vue";

Vue.component("AccountIcon", AccountIcon);
Vue.component("AccountNetworkIcon", AccountNetworkIcon);
Vue.component("AlertCircleOutlineIcon", AlertCircleOutlineIcon);
Vue.component("AlertIcon", AlertIcon);
Vue.component("AlertOctagonOutlineIcon", AlertOctagonOutlineIcon);
Vue.component("ArchiveAlertOutlineIcon", ArchiveAlertOutlineIcon);
Vue.component("ArchiveIcon", ArchiveIcon);
Vue.component("ArrowDownIcon", ArrowDownIcon);
Vue.component("ArrowDownThickIcon", ArrowDownThickIcon);
Vue.component("ArrowLeftIcon", ArrowLeftIcon);
Vue.component("ArrowRightCircleOutlineIcon", ArrowRightCircleOutlineIcon);
Vue.component("ArrowRightIcon", ArrowRightIcon);
Vue.component("ArrowUpIcon", ArrowUpIcon);
Vue.component("ArrowUpThickIcon", ArrowUpThickIcon);
Vue.component("AtIcon", AtIcon);
Vue.component("AttachmentIcon", AttachmentIcon);
Vue.component("AutoRenewIcon", AutoRenewIcon);
Vue.component("AutoRenewOffIcon", AutoRenewOffIcon);
Vue.component("BellAlertIcon", BellAlertIcon);
Vue.component("BellIcon", BellIcon);
Vue.component("BellOffIcon", BellOffIcon);
Vue.component("BellSleepIcon", BellSleepIcon);
Vue.component("BugIcon", BugIcon);
Vue.component("BullhornIcon", BullhornIcon);
Vue.component("CakeVariantIcon", CakeVariantIcon);
Vue.component("CalculatorIcon", CalculatorIcon);
Vue.component("CalendarCheckIcon", CalendarCheckIcon);
Vue.component("CalendarIcon", CalendarIcon);
Vue.component("CalendarMonthIcon", CalendarMonth);
Vue.component("CalendarPlusOutlineIcon", CalendarPlusOutlineIcon);
Vue.component("CancelIcon", CancelIcon);
Vue.component("CardPlusIcon", CardPlusIcon);
Vue.component("CheckAllIcon", CheckAllIcon);
Vue.component("CheckBoldIcon", CheckBoldIcon);
Vue.component("CheckCircleIcon", CheckCircleIcon);
Vue.component("CheckCircleOutlineIcon", CheckCircleOutlineIcon);
Vue.component("CheckIcon", CheckIcon);
Vue.component("CheckboxMarkedOutlineIcon", CheckboxMarkedOutline);
Vue.component("CheckboxMultipleOutlineIcon", CheckboxMultipleOutlineIcon);
Vue.component("CheckboxMultipleOutlineIcon", CheckboxMultipleOutlineIcon);
Vue.component("CheckboxOutlineIcon", CheckboxOutline);
Vue.component("ChevronDownIcon", ChevronDownIcon);
Vue.component("ChevronLeftIcon", ChevronLeftIcon);
Vue.component("ChevronRightIcon", ChevronRightIcon);
Vue.component("ChevronUpIcon", ChevronUpIcon);
Vue.component("ClockTimeIcon", ClockTimeIcon);
Vue.component("CloseCircleIcon", CloseCircleIcon);
Vue.component("CloseIcon", CloseIcon);
Vue.component("CloseOctagonIcon", CloseOctagonIcon);
Vue.component("CloseThickIcon", CloseThickIcon);
Vue.component("CogClockwiseIcon", CogClockwiseIcon);
Vue.component("CogIcon", CogIcon);
Vue.component("CogOffOutlineIcon", CogOffOutlineIcon);
Vue.component("CogOutlineIcon", CogOutlineIcon);
Vue.component("CommentOutlineIcon", CommentOutlineIcon);
Vue.component("CommentTextOutlineIcon", CommentTextOutlineIcon);
Vue.component("ContentCopyIcon", ContentCopyIcon);
Vue.component("ContentCutIcon", ContentCutIcon);
Vue.component("ContentSaveIcon", ContentSaveIcon);
Vue.component("CreditCardIcon", CreditCardIcon);
Vue.component("DatabaseSyncIcon", DatabaseSyncIcon);
Vue.component("DeleteIcon", DeleteIcon);
Vue.component("DotsVerticalIcon", DotsVerticalIcon);
Vue.component("DownloadIcon", DownloadIcon);
Vue.component("EmailFastIcon", EmailFastIcon);
Vue.component("EmailIcon", EmailIcon);
Vue.component("EmailLockIcon", EmailLockIcon);
Vue.component("EmailMultipleOutlineIcon", EmailMultipleOutlineIcon);
Vue.component("EmailOutlineIcon", EmailOutlineIcon);
Vue.component("EmailPlusOutlineIcon", EmailPlusOutlineIcon);
Vue.component("EmailRemoveIcon", EmailRemoveIcon);
Vue.component("EmailSearchIcon", EmailSearchIcon);
Vue.component("EyeCheckIcon", EyeCheckIcon);
Vue.component("EyeIcon", EyeIcon);
Vue.component("EyeOffIcon", EyeOffIcon);
Vue.component("FileChartIcon", FileChartIcon);
Vue.component("FileCodeIcon", FileCodeIcon);
Vue.component("FileExcelIcon", FileExcelIcon);
Vue.component("FileIcon", FileIcon);
Vue.component("FileImageIcon", FileImageIcon);
Vue.component("FilePdfIcon", FilePdfIcon);
Vue.component("FilePlusIcon", FilePlusIcon);
Vue.component("FileWordIcon", FileWordIcon);
Vue.component("FilterIcon", FilterIcon);
Vue.component("FilterVariantIcon", FilterVariantIcon);
Vue.component("GenderFemaleIcon", GenderFemaleIcon);
Vue.component("GenderMaleIcon", GenderMaleIcon);
Vue.component("HelpCircleOutlineIcon", HelpCircleOutlineIcon);
Vue.component("HelpIcon", HelpIcon);
Vue.component("HomeAlertIcon", HomeAlertIcon);
Vue.component("HomeAnalyticsIcon", HomeAnalyticsIcon);
Vue.component("HomeIcon", HomeIcon);
Vue.component("InformationOutlineIcon", InformationOutlineIcon);
Vue.component("LanIcon", LanIcon);
Vue.component("LinkVariantIcon", LinkVariantIcon);
Vue.component("LinkVariantOffIcon", LinkVariantOffIcon);
Vue.component("LoadingIcon", LoadingIcon);
Vue.component("MagnifyIcon", MagnifyIcon);
Vue.component("MagnifyIcon", MagnifyIcon);
Vue.component("MenuIcon", MenuIcon);
Vue.component("MenuOpenIcon", MenuOpenIcon);
Vue.component("MessageIcon", MessageIcon);
Vue.component("MicrosoftOutlookIcon", MicrosoftOutlookIcon);
Vue.component("NoteMultipleOutlineIcon", NoteMultipleOutlineIcon);
Vue.component("NotePlusOutlineIcon", NotePlusOutline);
Vue.component("OfficeBuildingIcon", OfficeBuildingIcon);
Vue.component("PackageIcon", PackageIcon);
Vue.component("PaletteIcon", PaletteIcon);
Vue.component("PencilIcon", PencilIcon);
Vue.component("PhoneIcon", PhoneIcon);
Vue.component("PhoneReturnIcon", PhoneReturnIcon);
Vue.component("PlayIcon", PlayIcon);
Vue.component("PlaylistCheckIcon", PlaylistCheckIcon);
Vue.component("PlusIcon", PlusIcon);
Vue.component("PowerIcon", PowerIcon);
Vue.component("PowerOffIcon", PowerOffIcon);
Vue.component("ResistorNodesIcon", ResistorNodesIcon);
Vue.component("RestoreIcon", RestoreIcon);
Vue.component("SackPercentIcon", SackPercentIcon);
Vue.component("SelectionMultipleIcon", SelectionMultipleIcon);
Vue.component("SendCheckIcon", SendCheckIcon);
Vue.component("SendClockIcon", SendClockIcon);
Vue.component("SendIcon", SendIcon);
Vue.component("ServerIcon", ServerIcon);
Vue.component("SignalVariantIcon", SignalVariantIcon);
Vue.component("SlashForwardIcon", SlashForwardIcon);
Vue.component("SlashForwardIcon", SlashForwardIcon);
Vue.component("StarIcon", StarIcon);
Vue.component("StarOutlineIcon", StarOutlineIcon);
Vue.component("SyncCircleIcon", SyncCircleIcon);
Vue.component("SyncOffIcon", SyncOffIcon);
Vue.component("TagIcon", TagIcon);
Vue.component("TargetAccountIcon", TargetAccountIcon);
Vue.component("ToolboxIcon", ToolboxIcon);
Vue.component("TooltipTextOutlineIcon", TooltipTextOutlineIcon);
Vue.component("TrashIcon", TrashIcon);
Vue.component("UmbrellaIcon", UmbrellaIcon);
Vue.component("UnfoldMoreHorizontalIcon", UnfoldMoreHorizontalIcon);
Vue.component("UploadIcon", UploadIcon);
Vue.component("UploadOutlineIcon", UploadOutline);
Vue.component("ViewModuleIcon", ViewModuleIcon);
Vue.component("SyncIcon", SyncIcon);
